var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowReturnLeftOutline24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.236 3.2636a.9.9 0 0 1 0 1.2728L7.6724 7.1h4.3272c3.2585 0 5.9 2.6415 5.9 5.9s-2.6415 5.9-5.9 5.9h-4.1a.9.9 0 0 1-.9-.9.9.9 0 0 1 .9-.9h4.1c2.2644 0 4.1-1.8356 4.1-4.1 0-2.2644-1.8356-4.1-4.1-4.1H7.6724l2.5636 2.5636a.9.9 0 0 1 0 1.2728.9001.9001 0 0 1-1.2728 0l-4.1-4.1a.9.9 0 0 1 0-1.2728l4.1-4.1a.9.9 0 0 1 1.2728 0Z",
  clipRule: "evenodd"
})));
export { SvgArrowReturnLeftOutline24 as ReactComponent };